/**
 * Module definition houses global error services
 *
 * @module services.error
 */
angular.module('services.error', [
  'services.error.ErrorService'
]);
